<template>
  <WdsStack direction-row gap-sm>
    <WdsTag :[status.color]="true">
      {{ status.text }}
    </WdsTag>

    <WdsTag v-if="removed" error>
      {{ $t('Removed') }}
    </WdsTag>
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsStack, WdsTag } from '@worksome/wds-components'

import { $t } from '@/composables/translation'

const props = defineProps({
  removed: {
    type: Boolean,
    default: false,
  },

  paused: {
    type: Boolean,
    default: false,
  },

  published: {
    type: Boolean,
    default: false,
  },

  available: {
    type: Boolean,
    default: false,
  },

  completed: {
    type: Boolean,
    default: false,
  },
})

const status = computed<{
  color: string
  text: string
}>(() => {
  if (!props.published) {
    return {
      color: 'gray',
      text: $t('Draft'),
    }
  }

  if (props.completed) {
    return {
      color: 'primary',
      text: $t('Completed'),
    }
  }

  if (props.paused) {
    return {
      color: 'warning',
      text: $t('Paused'),
    }
  }

  if (!props.available) {
    return {
      color: 'primary',
      text: $t('Not available'),
    }
  }

  return {
    color: 'success',
    text: $t('Available'),
  }
})
</script>
